var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsbx: "https://boxy-svg.com",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.5 0.494378",
    fill: "#FFF",
    d: "m18.316 5.684-5.684-.631-6.948.631L5.053 12l.631 6.316 6.316.789 6.316-.789.631-6.474-.631-6.158Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.528968 0.484776",
    fill: "#1A73E8",
    d: "M8.275 15.483c-.472-.319-.799-.785-.977-1.4l1.096-.452c.099.379.273.673.521.881.246.209.546.311.897.311.358 0 .666-.109.923-.327.258-.218.387-.496.387-.832 0-.344-.136-.625-.407-.843-.272-.218-.613-.327-1.02-.327h-.633v-1.085h.568c.351 0 .646-.094.886-.284.24-.189.36-.448.36-.778 0-.294-.108-.528-.322-.703-.215-.175-.487-.263-.817-.263-.322 0-.578.085-.767.257-.189.172-.327.384-.414.633L7.472 9.82c.143-.408.407-.768.794-1.079.387-.311.881-.467 1.481-.467.444 0 .843.085 1.197.257.353.172.631.411.832.714.2.304.3.646.3 1.024 0 .387-.093.714-.28.983-.186.268-.415.473-.687.617v.065c.359.15.651.379.882.687.228.307.344.675.344 1.105 0 .429-.109.813-.327 1.149-.218.337-.52.602-.902.794-.383.193-.814.291-1.293.291-.554.002-1.066-.158-1.538-.477ZM15 10.045l-1.197.87-.601-.912 2.158-1.557h.827v7.343H15v-5.744Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "-0.727364 -0.727364",
    fill: "#EA4335",
    d: "M18.316 24 24 18.316l-2.842-1.263-2.842 1.263-1.263 2.842L18.316 24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.545448 -1.111189",
    fill: "#34A853",
    d: "M4.421 21.158 5.684 24h12.632v-5.684H5.684l-1.263 2.842Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.612902 0.612902",
    fill: "#4285F4",
    d: "M1.895 0C.848 0 0 .848 0 1.895v16.421l2.842 1.263 2.842-1.263V5.684h12.632l1.263-2.842L18.316 0H1.895Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "2.111189 -1.111189",
    fill: "#188038",
    d: "M0 18.316v3.789C0 23.152.848 24 1.895 24h3.789v-5.684H0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "-1.111189 0.545448",
    fill: "#FBBC04",
    d: "M18.316 5.684v12.632H24V5.684l-2.842-1.263-2.842 1.263Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "-1.111189 2.111189",
    fill: "#1967D2",
    d: "M24 5.684V1.895C24 .848 23.152 0 22.105 0h-3.789v5.684H24Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google_calendar.35ce64de2540b7eda8f078d1ae30adc6.svg";
export { ForwardRef as ReactComponent };